// import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import React from "react";

const ErrorFallback = () => {
    // const error: any = useRouteError();
    // console.error(error);

    // let errorMessage = "An unexpected error has occurred.";

    // if (isRouteErrorResponse(error)) {
    //     errorMessage = error.statusText || error.data?.message || "Unknown error";
    // } else if (error instanceof Error) {
    //     errorMessage = error.message;
    // } else if (typeof error === 'string') {
    //     errorMessage = error;
    // }

    return (
        <div className="flex h-screen w-full flex-col items-center justify-center gap-6 bg-white p-4 text-center dark:bg-navy-900">
            <div className="flex flex-col items-center gap-2">
                <h1 className="text-4xl font-bold text-navy-700 dark:text-white">
                    Oops!
                </h1>
                <h2 className="text-lg font-bold text-gray-600 dark:text-gray-300">
                    Something went wrong here.
                </h2>
            </div>

            {/* <div className="max-w-md rounded bg-red-50 p-4 text-left dark:bg-red-900/20">
                <p className="font-mono text-sm text-red-600 dark:text-red-300 break-words">
                    {errorMessage}
                </p>
            </div> */}

            <div className="flex gap-4">
                <Button
                    colorScheme="gray"
                    onClick={() => window.history.back()}
                >
                    Go Back
                </Button>
                <Button
                    colorScheme="brand"
                    className="bg-brand-500 hover:bg-brand-600 text-white"
                    onClick={() => window.location.reload()}
                >
                    Refresh Page
                </Button>
            </div>
        </div>
    );
};

export default ErrorFallback;
